import * as React from "react";
import EmailNotificationForm from "./EmailNotificationForm";
const EmailNotificationFormContainer = (props) => /* @__PURE__ */ React.createElement(EmailNotificationForm, { ...props });
export default EmailNotificationFormContainer;
